import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-body-block',
  template: require('./body-block.component.html'),
  // styles: [require('./body-block.component.css')]
})
export class BodyBlockComponent implements OnInit {

  constructor() {
    // this.loadScripts();
  }

  // loadScripts() {
  //   const externalScriptArray = [
  //     'https://code.highcharts.com/modules/accessibility.js',
  //     'https://code.highcharts.com/modules/export-data.js',
  //     'https://code.highcharts.com/modules/exporting.js',
  //     'https://code.highcharts.com/highcharts-3d.js',
  //     'https://code.highcharts.com/highcharts.js',
  //     '../assets/js/map.js',
  //     '../assets/js/chart.js',
  //     '../assets/js/status.js',



  //   ];
  //   for (let i = 0; i < externalScriptArray.length; i++) {
  //     const scriptTag = document.createElement('script');
  //     scriptTag.src = externalScriptArray[i];
  //     scriptTag.type = 'text/javascript';
  //     scriptTag.async = false;
  //     scriptTag.charset = 'utf-8';
  //     document.getElementsByTagName('head')[0].appendChild(scriptTag);
  //   }
  // }
  ngOnInit() {
  }

}
